function updateFabricLabels() {
  const configs = {
    "Cotton Blend": "30% Cotton / 70% Polyester",
    "UV Protection": "UPF 50+"
  };

  Object.entries(configs).forEach(([title, subtitleText]) => {
    document
      .querySelectorAll(`label.tee-radio-label--color[title="${title}"]`)
      .forEach(label => {
        if (label.querySelector(".fabric-composition")) return;

        label.style.flexDirection = "column";

        const existingSpan = label.querySelector("span");
        if (existingSpan) {
          existingSpan.style.display = "block";
        }

        const subtitle = document.createElement("span");
        subtitle.className = "fabric-composition";
        subtitle.textContent = subtitleText;
        subtitle.style.cssText = `
          display:block;
          font-size:10px;
          font-weight:normal;
          margin-top:2px;
        `;

        label.appendChild(subtitle);
      });
  });
}

document.addEventListener("teeinblue-event-component-injected", () => {

  const headings = document.querySelectorAll(".tee-field__heading");

  headings.forEach(el => {
    if (el.innerText.toLowerCase().includes("preview method")) {
      if (!el.parentElement.querySelector(".tee-field__help")) {
        const helpText = document.createElement("div");
        helpText.className = "tee-field__help";
        helpText.innerText =
          "Instant preview may not work with some images. You can upload for manual design instead.";

        el.insertAdjacentElement("afterend", helpText);
      }
    }
  });



  
  const field = document.querySelector(".tee-field--template");

  if (field) {
    const helpText = field.querySelector(".tee-field__help");
    const heading = field.querySelector(".tee-field__heading");
    const selectWrapper = field.querySelector(".tee-select-wrapper");
    const select = field.querySelector(".tee-field__select");
    const previewBtn = document.querySelector(".tee-btn--preview");

    const TEXT_UPLOAD = "Need human support for your design? Click here!";
    const TEXT_PREVIEW = "Back to live preview";

    if (helpText && heading && selectWrapper && select) {

      helpText.style.cursor = "pointer";
      helpText.style.fontSize = "16px";
      helpText.textContent = TEXT_UPLOAD;

      helpText.addEventListener("click", function () {
        const isUploadMode = helpText.textContent === TEXT_UPLOAD;

        heading.style.display = "";
        selectWrapper.style.display = "";

        if (isUploadMode) {
          select.value = select.querySelector("option:last-child").value;
          helpText.textContent = TEXT_PREVIEW;

          if (previewBtn) previewBtn.style.display = "none";
        } else {
          select.value = select.querySelector("option:nth-child(2)").value;
          helpText.textContent = TEXT_UPLOAD;

          if (previewBtn) previewBtn.style.display = "";
        }

        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  // Add fabric labels
  updateFabricLabels();

  const handle = window.location.pathname.toLowerCase();


  const isPolo = handle.includes("polo");

  if (isPolo) {
    const fields = document.querySelectorAll(".tee-field");

    fields.forEach(field => {
      const heading = field.querySelector(".tee-field__heading");
      if (!heading) return;

      const text = heading.innerText.trim();

      if (text.includes("Pocket")) {
        field.style.display = "none";
      }
    });
  }

  // START CODE: PICK A SIZE
  (() => {
    let sizeSelected = false;

    const ERROR_TEXT = '*Please pick a size in order to add this item to your cart.';

    const getSizeContainer = () => {
      return (
        document.querySelector(
          '.tee-row.tee-option-inner[role="radiogroup"][aria-labelledby="label-size"]'
        ) ||
        document.querySelector('.tee-option--size .tee-option-inner') ||
        document.querySelector('.tee-option--size')
      );
    };

    const showSizeError = (container) => {
      const targetContainer = container || getSizeContainer();
      if (!targetContainer) return;

      let errorEl = document.querySelector('#tee-size-error-message');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.id = 'tee-size-error-message';
        errorEl.className = 'tee-size-error-message';
        errorEl.textContent = ERROR_TEXT;
        errorEl.style.cssText = `
          color: #e53e3e;
          font-size: 13px;
          margin-top: 8px;
          font-weight: 500;
          line-height: 1.4;
          display: block;
        `;
      }

      if (targetContainer.parentNode && targetContainer.nextElementSibling !== errorEl) {
        targetContainer.insertAdjacentElement('afterend', errorEl);
      }
      errorEl.style.display = 'block';
    };

    const hideSizeError = () => {
      const errorEl = document.querySelector('#tee-size-error-message');
      if (errorEl) {
        errorEl.remove();
      }
    };

    // =========================================
    // Reset về trạng thái "chưa chọn size"
    // =========================================
    const resetSizeSelection = () => {
      const addToCartButton = document.querySelector('#teeAtcButton');
      const sizeContainer = getSizeContainer();

      if (!addToCartButton || !sizeContainer) return;

      sizeSelected = false;

      // 1. Bỏ hết active trên size UI
      sizeContainer.querySelectorAll('.tee-radio').forEach((radio) => {
        radio.classList.remove('active');
        radio.removeAttribute('aria-checked');

        const input = radio.querySelector('input[type="radio"]');
        if (input) {
          input.checked = false;
          input.removeAttribute('checked');
        }
      });

      // 2. Ẩn thông báo lỗi nếu có
      hideSizeError();
    };

    const handleCartDrawerOpened = () => {
      resetSizeSelection();
    };

    // =========================================
    // Khởi tạo logic chọn size
    // =========================================
    const initTeeinblueSizeControl = () => {
      const addToCartButton = document.querySelector('#teeAtcButton');
      const sizeContainer = getSizeContainer();

      if (!addToCartButton || !sizeContainer) return false;

      // Initial reset
      resetSizeSelection();

      // =========================================
      // 3. INTERCEPT Add To Cart (capture phase)
      // =========================================
      if (!addToCartButton.dataset.sizeControlInitialized) {
        addToCartButton.dataset.sizeControlInitialized = 'true';

        addToCartButton.addEventListener(
          'click',
          (event) => {
            const currentSizeContainer = getSizeContainer() || sizeContainer;

            if (!sizeSelected) {
              event.preventDefault();
              event.stopImmediatePropagation();

              showSizeError(currentSizeContainer);

              currentSizeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

              const firstSize = currentSizeContainer.querySelector('input[type="radio"]');
              if (firstSize) {
                setTimeout(() => firstSize.focus(), 400);
              }

              return false;
            }

            hideSizeError();
            console.log('Size selected -> Add To Cart');
          },
          true // CAPTURE PHASE
        );
      }

      // =========================================
      // 4. Detect user chọn size
      // =========================================
      if (!sizeContainer.dataset.sizeControlInitialized) {
        sizeContainer.dataset.sizeControlInitialized = 'true';

        const onSizeSelected = (input) => {
          sizeSelected = true;
          console.log('Selected size:', input?.value);

          hideSizeError();

          // Sync Teeinblue UI
          sizeContainer.querySelectorAll('.tee-radio').forEach((r) => r.classList.remove('active'));
          const activeRadio = input?.closest('.tee-radio');
          if (activeRadio) activeRadio.classList.add('active');
        };

        sizeContainer.addEventListener('change', (event) => {
          const input = event.target.closest('input[type="radio"]');
          if (!input) return;
          onSizeSelected(input);
        });

        sizeContainer.addEventListener('click', (event) => {
          const radioWrapper = event.target.closest('.tee-radio');
          if (radioWrapper) {
            const input = radioWrapper.querySelector('input[type="radio"]');
            onSizeSelected(input);
          }
        });
      }

      return true;
    };

    // =========================================
    // 5. Lắng nghe sự kiện mở Cart Drawer & ATC
    // =========================================
    if (!window._teeinblueCartListenersAttached) {
      window._teeinblueCartListenersAttached = true;

      document.addEventListener('teeinblue-event-after-cart-added', () => {
        handleCartDrawerOpened();
      });

      document.addEventListener(
        'dialog:open',
        (event) => {
          const target = event.target;
          if (
            target &&
            (target.matches?.('cart-drawer-component') ||
              target.closest?.('cart-drawer-component') ||
              target.classList?.contains('cart-drawer__dialog'))
          ) {
            handleCartDrawerOpened();
          }
        },
        true
      );

      document.addEventListener('cart:update', () => {
        handleCartDrawerOpened();
      });

      const observeCartDialog = () => {
        const cartDialog = document.querySelector('cart-drawer-component dialog');
        if (cartDialog) {
          const dialogObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.attributeName === 'open' && cartDialog.hasAttribute('open')) {
                handleCartDrawerOpened();
              }
            }
          });
          dialogObserver.observe(cartDialog, { attributes: true, attributeFilter: ['open'] });
          return true;
        }
        return false;
      };

      if (!observeCartDialog()) {
        const docObserver = new MutationObserver(() => {
          if (observeCartDialog()) docObserver.disconnect();
        });
        docObserver.observe(document.body, { childList: true, subtree: true });
      }
    }

    // Teeinblue render async
    if (!initTeeinblueSizeControl()) {
      const observer = new MutationObserver(() => {
        if (initTeeinblueSizeControl()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();
  // END CODE: PICK A SIZE

});

// Observe TeeInBlue re-render
const observer = new MutationObserver(() => {
  updateFabricLabels();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener("click", e => {
  console.log("listen clicke");

  const contactBtn = e.target.closest(".contact-us-teeinblue");


  if (!contactBtn) return;


  document
    .querySelector(
      'button[popovertarget="CallNowPopover-mobile-hidden"]'
    )
    ?.click();
});